import { useAppContext } from '@contexts/AppContext';
import { FeatureFlags } from '@utils/enums';

export interface FeatureFlagProps {
  flag: FeatureFlags;
}

interface FeatureFlagResponse {
  flagEnabled: boolean;
  flagValue: boolean | string | undefined;
}

export default function useFeatureFlag({ flag }: FeatureFlagProps): FeatureFlagResponse {
  const { initialCurrentUser } = useAppContext();
  const userFlags = initialCurrentUser?.feature_flags;
  const value = userFlags?.[flag];

  return {
    flagEnabled: !!value,
    flagValue: value,
  };
}
